// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b1827489","453":"b4be46f2","455":"3fec6b1d","977":"91c6a444"}[chunkId] + ".chunk.js";
};